import { InstantInput as InstantInputField } from "@/components/form"
import { type Instant } from "@/temporal"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"
import type { GenericInputProps } from "./InputComponent"

type Props = GenericInputProps<Instant>

const InstantInput: ReactiveComponent<Props> = (props) => {
	return () => <InstantInputField value={props.value} setValue={props.setValue} />
}

export default defineComponent(InstantInput, inferProps<Props>())
